const e = "";
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/inputTypeItem/index.vue3.js
// module id = 1216
// module chunks = 41